<template>
  <iframe
    v-if="fileReady"
    :src="`${file.link}#toolbar=0&navpanes=0`"
    :style="`width:100%; height:calc(100vh - ${minusHeight}px);`"
    frameborder="0"
  ></iframe>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";

export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    }
  },
  data() {
    return {
      fileReady: false,
      file: {},
      deletingFileId: 0
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.file = res.data.file;
            this.fileReady = true;
          }
        }
      );
    }
  }
};
</script>
